export default __webpack_public_path__ + "5e2f67bd6a192469914632332b7319d3.png";